export {default} from './TeamDetailModel';
export {TeamDetailModelType} from './TeamDetailModel';



// WEBPACK FOOTER //
// ./src/models/TeamDetailModel/index.ts